import React, { Component } from 'react'
import PropTypes from 'prop-types'
import '../styles/button.css'

class Button extends Component {
  render () {
    return (
      <a id={this.props.id} className={'button' + (this.props.classes !== undefined ? ' ' + this.props.classes : '')} href={this.props.href} target={this.props.target} rel='noopener'>
        {this.props.icon !== undefined && <i className={'ac ' + this.props.icon} />}
        {this.props.text}
      </a>
    )
  }
}

Button.propTypes = {
  id: PropTypes.string,
  classes: PropTypes.array,
  href: PropTypes.string,
  target: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string.isRequired
}

export default Button



// WEBPACK FOOTER //
// ./src/components/Button.js